// Metric display names and codec information for dynamic chart generation
// Used primarily by ModbusMeter and other generic devices

export const metricDisplayNames = {
  u: "Spannung [V]",
  i: "Strom [A]",
  p: "Wirkleistung [kW]",
  f: "Frequenz [Hz]",
  cosphi: "cos(phi)",
  activeEnergy: "Energie [kWh]",
  reactiveEnergy: "Blindenergie [ kvarh]",
  apparentEnergy: "Scheinenergie [kVAh]",
};

// Codecs that should not be plotted as charts (binary/text data)
export const NON_CHARTABLE_CODECS = ["Hex", "Ascii"];

